export default "query embargoedAsset($publicId:String!) {\n    embargoedAsset(publicId: $publicId)\n}\n";